(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Set();
  function animate(element, frames, options) {
    if (reduced.matches || !element?.animate) return;
    const animation = element.animate(frames, options);
    running.add(animation);
    animation.finished.then(() => running.delete(animation), () => running.delete(animation));
  }

  document.querySelectorAll('.button').forEach(button => {
    button.addEventListener('pointerdown', event => {
      if (reduced.matches || button.disabled) return;
      const rect = button.getBoundingClientRect();
      const wave = document.createElement('span');
      wave.className = 'button-wave'; wave.setAttribute('aria-hidden', 'true');
      wave.style.left = (event.clientX - rect.left) + 'px';
      wave.style.top = (event.clientY - rect.top) + 'px';
      button.append(wave); setTimeout(() => wave.remove(), 650);
    });
  });

  // Play each detail once, when it is actually on screen. Nothing moves the page layout.
  if ('IntersectionObserver' in window) {
    const entrances = '.compact-benefits > div, .gallery-thumbs .thumb, .purchase-trust > a';
    const shines = '.hero-actions .button, #add-cart, #mobile-add, .delivery-highlight, .final-cta .button';
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({target, isIntersecting}) => {
        if (!isIntersecting) return;
        observer.unobserve(target);
        if (reduced.matches) return;
        target.classList.add('motion-entered');
        if (target.matches(entrances)) {
          const position = [...target.parentElement.children].indexOf(target);
          animate(target, [
            {opacity:.25, transform:'translate3d(0,12px,0)'},
            {opacity:1, transform:'translate3d(0,0,0)'}
          ], {duration:560, delay:Math.min(position, 2) * 80, easing:'cubic-bezier(.2,.75,.2,1)', fill:'backwards'});
        }
        if (target.matches(shines)) {
          const glint = document.createElement('span');
          glint.className = 'motion-glint';
          glint.setAttribute('aria-hidden', 'true');
          target.append(glint);
          setTimeout(() => glint.remove(), 1400);
        }
      });
    }, {threshold:.35, rootMargin:'0px 0px -12px 0px'});
    document.querySelectorAll(entrances + ', ' + shines).forEach(element => observer.observe(element));
  }

  document.querySelectorAll('.product-accordions details, .faq-list details').forEach(details => {
    details.addEventListener('toggle', () => {
      if (reduced.matches || !details.open) return;
      animate(details.querySelector('p'), [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 320, easing: 'ease-out' });
    });
  });

  const featureTabs = [...document.querySelectorAll('[data-feature-tab]')];
  const featureTablist = document.querySelector('.feature-tabs');
  if (featureTablist && featureTabs.length) {
    const compact = matchMedia('(max-width: 760px)');
    const featurePanels = featureTabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
    let activeFeature = 0;
    const updateOrientation = () => featureTablist.setAttribute('aria-orientation', compact.matches ? 'horizontal' : 'vertical');
    function selectFeature(index, moveFocus = false) {
      const next = (index + featureTabs.length) % featureTabs.length;
      const changed = next !== activeFeature;
      activeFeature = next;
      featureTabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === next));
        tab.tabIndex = i === next ? 0 : -1;
        featurePanels[i].hidden = i !== next;
      });
      if (moveFocus) featureTabs[next].focus({preventScroll:true});
      if (changed) {
        const panel = featurePanels[next];
        panel.getAnimations({subtree:true}).forEach(animation => animation.cancel());
        animate(panel.querySelector('.feature-picture img'), [
          {opacity:.55, transform:'scale(1.045)'},
          {opacity:1, transform:'scale(1)'}
        ], {duration:600, easing:'cubic-bezier(.2,.75,.2,1)'});
        animate(panel.querySelector('.feature-panel-copy'), [
          {opacity:0, transform:'translate3d(0,10px,0)'},
          {opacity:1, transform:'translate3d(0,0,0)'}
        ], {duration:360, easing:'ease-out'});
      }
    }
    featureTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectFeature(index));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = featureTabs.length - 1;
        else if (event.key === (compact.matches ? 'ArrowRight' : 'ArrowDown')) next = index + 1;
        else if (event.key === (compact.matches ? 'ArrowLeft' : 'ArrowUp')) next = index - 1;
        if (next === undefined) return;
        event.preventDefault();
        selectFeature(next, true);
      });
    });
    updateOrientation();
    compact.addEventListener('change', updateOrientation);
    featureTablist.hidden = false;
  }

  reduced.addEventListener('change', () => {
    if (!reduced.matches) return;
    running.forEach(animation => animation.cancel());
    document.querySelectorAll('.motion-glint, .button-wave').forEach(element => element.remove());
  });
})();
